import React from 'react'
import { translate } from 'react-admin'

const TranslatedEnumField = ({ translate, type, record, source }) => (
    <span>{translate(`enums.${type}.${record[source]}`)}</span>
);

export default translate(TranslatedEnumField);